import * as React from "react";

const SvgWifi = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill={color} fillRule="nonzero">
      <path d="M7.01 14.697a1 1 0 1 0 1.415 1.414L7.01 14.697ZM14.789 16.111a1 1 0 0 0 1.414-1.414l-1.414 1.414ZM11.607 18a1 1 0 1 0 0 2v-2ZM11.617 20a1 1 0 0 0 0-2v2ZM3.828 11.222a1 1 0 0 0 1.415 1.414l-1.415-1.414ZM17.97 12.636a1 1 0 0 0 1.415-1.414l-1.414 1.414ZM.293 7.686a1 1 0 1 0 1.414 1.415L.293 7.686ZM21.506 9.1a1 1 0 0 0 1.414-1.414l-1.414 1.415Z" />
      <path d="M8.425 16.111a4.5 4.5 0 0 1 6.364 0l1.414-1.414a6.5 6.5 0 0 0-9.193 0l1.415 1.414ZM11.607 20h.01v-2h-.01z" />
      <path d="M5.243 12.636a9 9 0 0 1 12.728 0l1.414-1.414c-4.296-4.296-11.26-4.296-15.557 0l1.415 1.414Z" />
      <path d="M1.707 9.1c5.467-5.467 14.332-5.467 19.8 0l1.413-1.414c-6.248-6.248-16.379-6.248-22.627 0l1.414 1.415Z" />
    </g>
  </svg>
);

export default SvgWifi;
